/// <amd-module name="SuiteCommerce.CookieConsent.Common.Utils"/>
define("SuiteCommerce.CookieConsent.Common.Utils", ["require", "exports", "Backbone", "SuiteCommerce.CookieConsent.Common.Configuration"], function (require, exports, Backbone_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = void 0;
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.isTheCookiePolicyPageOpen = function () {
            var websiteUrl = Backbone_1.history.location;
            var policyPageUrl = Configuration_1.Configuration.cookiePolicyPageLink;
            if (policyPageUrl) {
                return (!websiteUrl ||
                    websiteUrl.pathname.indexOf(policyPageUrl) !== -1 ||
                    websiteUrl.hash.indexOf(policyPageUrl) !== -1);
            }
            return false;
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
